import { Component } from "@angular/core"

import firebase from "firebase"

import { AppEnv } from "./app.env"
import { LoadingPage } from "../pages/loading"
import { AppTabPages } from "../pages/tabs"
import { LoginPage } from "../pages/login"

@Component({
  templateUrl: "app.html"
})
export class App {

  rootPage:any = LoadingPage

  constructor() {

    firebase.initializeApp(AppEnv.firebaseConfig)

    firebase.auth().onAuthStateChanged((user) => {

      if (user) {
        this.rootPage = AppTabPages
      } else {
        this.rootPage = LoginPage
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts